import isArray from 'lodash/isArray';

import { DEFAULT_PARAGRAPH } from '../constants';

import getPrepareChildren from './getPrepareChildren';

const getPrepareContent = (content) => {
  if (!content?.document) return content;

  const { nodes } = content.document;

  if (!nodes || !isArray(nodes) || nodes.length === 0) return [DEFAULT_PARAGRAPH];

  return getPrepareChildren(nodes);
};

export default getPrepareContent;
